// src/app/shared/bottom-sheet-dialog.config.ts
//
// Eine einzige Stelle, die entscheidet, wie ein Dialog auf dem Telefon
// erscheint. Vorher gab es dafuer fuenf Auspraegungen derselben Absicht --
// zwei vollstaendige (manual-search, add-landing) und sechs Aufrufe, die nur
// die panelClass setzten und deshalb vertikal zentriert blieben: ein Panel mit
// seitlichem Rand, runden oberen und eckigen unteren Ecken. Eckige untere
// Ecken stimmen nur, wenn das Sheet die Unterkante wirklich beruehrt, also
// gehoeren panelClass und `position: bottom` zusammen und werden nur hier
// gesetzt.

import type { MatDialogConfig } from '@angular/material/dialog';

/**
 * Spiegel von respond-to(sm) in theme/_mixins.scss ($bp-sm = 600px).
 *
 * Bewusst nicht `innerWidth < 600` (verfehlt die Grenze bei genau 600px, dort
 * greift das Mobile-SCSS aber schon) und nicht 599px: Dialogkonfiguration und
 * Komponenten-SCSS muessen dieselbe Grenze benutzen, sonst bekommt ein Dialog
 * bei exakt 600px Desktop-Geometrie und Mobile-Styles.
 */
const MOBILE_QUERY = '(max-width: 600px)';

export function isMobileViewport(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches;
}

type BottomSheetConfig = Pick<MatDialogConfig, 'width' | 'maxWidth' | 'position' | 'panelClass'>;

/**
 * Mobile: volle Breite, unten angedockt (Bottom-Sheet). Desktop: zentriert in
 * der uebergebenen Breite.
 *
 * @param desktopWidth    feste Breite auf Desktop, z.B. '600px'. Weglassen fuer
 *                        Dialoge, die sich ihrem Inhalt anpassen sollen.
 * @param desktopMaxWidth Obergrenze auf Desktop; ohne Angabe gleich
 *                        desktopWidth.
 *
 * Per Spread in dialog.open() verwenden, damit dialogspezifische Optionen
 * (data, autoFocus, maxHeight) daneben stehen bleiben:
 *
 *   this.dialog.open(Foo, { ...bottomSheetDialogConfig('600px'), data });
 */
export function bottomSheetDialogConfig(
  desktopWidth?: string,
  desktopMaxWidth?: string,
): BottomSheetConfig {
  if (isMobileViewport()) {
    // `left`/`right` waeren hier wirkungslos: bei width 100% + maxWidth 100vw
    // erzwingt die GlobalPositionStrategy ohnehin justifyContent flex-start
    // und marginLeft/Right 0.
    return {
      width: '100%',
      maxWidth: '100vw',
      position: { bottom: '0' },
      panelClass: 'dialog-bottom-sheet',
    };
  }

  return {
    width: desktopWidth,
    maxWidth: desktopMaxWidth ?? desktopWidth,
    position: undefined,
    panelClass: '',
  };
}
